<template>
    <button
        :id="btnId"
        type="button"
        class="w-full bg-gold shadow rounded-5px text-dark-3 text-base font-medium text-center font-main-medium"
        :class="{ 'opacity-30': isBtnDisable }"
        @click="clickButton()"
        data-cy="btn_button_primary"
    >
        <span data-cy="text_button_primary_label" v-html="btnMsg"></span>
    </button>
</template>
<script>
export default {
    name: 'PrimaryButton',
    props: {
        btnId: [String, Number],
        btnMsg: String,
        isBtnDisable: Boolean
    },
    emits: ["onClick"],
    methods: {
        clickButton: function () {
            if (this.isBtnDisable) return;

            this.$emit('onClick');
        }
    }
}
</script>

<style lang="scss" scoped>
button {
    height: 45px;
}
</style>
